import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppService, AppSettingService } from '../../app.service';
//import { ActionIconComponent } from '../../territoryCard/action-icon.component';

@Component({
	selector: 'app-action-icon-open-folder',
	templateUrl: "./action-icon-open-folder.component.html",
	standalone: false
})
export class ActionIconOpenFolderComponent implements OnInit {
	@Input() isMobile: boolean = false;
	@Input() folderData: any;
	constructor(
		private router: Router
	) { }
	onSelected() {		
		this.router.navigateByUrl("/FileManagement?topFolderId=" + this.folderData.FolderId);
	}

	ngOnInit(): void {		
	}
}
